import { getEnv } from './';

export const getPTAUrl = (location, urlName) => {
    const urls = {
        login: {
            prod: `/monopoly/login/index.php`,
            uat: `https://gasc1playdigital.dev.igt.com/en-us/games/second-chance/2021monopoly.html`,
            qa: `/monopoly/enter/testlogin.php`,
            dev: `/users/login`,
        },
        logout: {
            prod: `https://www.galottery.com/en-us/logout.html`,
            uat: `https://gasc1playdigital.dev.igt.com/en-us/logout.html`,
            qa: `https://gasc1playdigital.dev.igt.com/en-us/logout.html`,
            dev: `https://gasc1playdigital.dev.igt.com/en-us/logout.html`,
        },
        register: {
            prod: `https://www.galottery.com/en-us/registration.html?utm_source=organic&utm_medium=secondchance&utm_campaign=monopoly&utm_content=registration`,
            uat: `https://gasc1playdigital.dev.igt.com/en-us/registration.html`,
            qa: `https://gasc1playdigital.dev.igt.com/en-us/registration.html`,
            dev: `https://gasc1playdigital.dev.igt.com/en-us/registration.html`,
        },
        profile: {
            prod: `https://www.galottery.com/en-us/myaccount/my-profile.html`,
            uat: `https://gasc1playdigital.dev.igt.com/en-us/myaccount/my-profile.html`,
            qa: `https://www.galottery.com/en-us/myaccount/my-profile.html`,
            dev: `https://www.galottery.com/en-us/myaccount/my-profile.html`,
        },
    };

    return urls[urlName][getEnv(location)];
};
